import { Ord } from "fp-ts/Ord";
import { EnrichedSwarovskiProductFrontend } from "@swo/storefront";
import { ord } from "fp-ts";
import { productNameOrd } from "@swo/shared";

export const enrichedSwarovskiProductFrontendOrd: Ord<EnrichedSwarovskiProductFrontend> = ord.contramap<
  string,
  EnrichedSwarovskiProductFrontend
>(p => p.name)(productNameOrd);
